/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ZhWhyCheckPlus.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuZh from "../../assets/component/HomepageMenuZh/HomepageMenuZh.js";

class ZhWhyCheckPlus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="ZhWhyCheckPlus-view">
        <Helmet>
          <title>為什麼選擇 CheckPlus？ - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuZh closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="ZhWhyCheckPlus-first">
          <div className="ZhWhyCheckPlus-heading">為什麼選擇 CheckPlus？</div>
          <div className="ZhWhyCheckPlus-scrollContainer">
            <div className="ZhWhyCheckPlus-space">
              <div className="ZhWhyCheckPlus-centerContent" />
            </div>
            <div className="ZhWhyCheckPlus-box">
              <div className="ZhWhyCheckPlus-centerContent">
                <div className="ZhWhyCheckPlus-CheckPlusLogoCircle">
                  <div className="ZhWhyCheckPlus-CheckPlusLogo" />
                </div>

                <div className="ZhWhyCheckPlus-logoTxt">CheckPlus</div>
                <div className="ZhWhyCheckPlus-list">
                  + 每月低至 HK$150 <p />+ 多種功能 <p />+ 簡單使用
                </div>
              </div>
            </div>
            <div className="ZhWhyCheckPlus-box">
              <div className="ZhWhyCheckPlus-centerContent">
                <div className="ZhWhyCheckPlus-developerIcn" />

                <div className="ZhWhyCheckPlus-developerTxt">
                  僱用軟件開發人員
                </div>
                <div className="ZhWhyCheckPlus-list">
                  - 開發成本昂貴和維護費用 (每月$2-20k) <p />- 開發時間長 <p />-
                  潛在系統問題
                </div>
              </div>
            </div>
            <div className="ZhWhyCheckPlus-box">
              <div className="ZhWhyCheckPlus-centerContent">
                <div className="ZhWhyCheckPlus-banksIcn" />

                <div className="ZhWhyCheckPlus-developerTxt">
                  銀行或支付網關
                </div>
                <div className="ZhWhyCheckPlus-list">
                  - 功能不足 <p />- 耗時的管理 <p />- 不容易操作
                </div>
              </div>
            </div>
            <div className="ZhWhyCheckPlus-space2">
              <div className="ZhWhyCheckPlus-centerContent" />
            </div>
          </div>
          <div className="ZhWhyCheckPlus-content">
            <div className="ZhWhyCheckPlus-checkplusCircle" />
            <div className="ZhWhyCheckPlus-heading">
              我們如何設計 CheckPlus？
            </div>
            <div className="ZhWhyCheckPlus-subheading">
              CheckPlus 擁有自己的開發人員團隊，並與 Stripe、PayPal 和 匯豐
              合作去建立平台。
            </div>
          </div>
        </div>

        <div className="ZhWhyCheckPlus-second">
          <div className="ZhWhyCheckPlus-heading ZhWhyCheckPlus-whiteTxt">
            CheckPlus 功能
          </div>
        </div>

        <div className="ZhWhyCheckPlus-first">
          <div className="ZhWhyCheckPlus-content">
            <div className="ZhWhyCheckPlus-heading">1. 建立捐款網頁</div>
            <div className="ZhWhyCheckPlus-subheading">
              透過 CheckPlus，系統會自動為閣下的機構準備一個捐款網頁。
            </div>
            <div className="ZhWhyCheckPlus-feature1" />
            <div className="ZhWhyCheckPlus-heading">2. 收集捐款者資料</div>
            <div className="ZhWhyCheckPlus-subheading">
              CheckPlus 不僅會收集付款資料，還會收集付款者/捐款者數據。
            </div>
            <div className="ZhWhyCheckPlus-feature2" />
            <div className="ZhWhyCheckPlus-heading">3. 接受多個付款方式</div>
            <div className="ZhWhyCheckPlus-subheading">
              付款者/捐款者會看到以下付款方式。
            </div>
            <div className="ZhWhyCheckPlus-CC" />
            <div className="ZhWhyCheckPlus-ApplePay" />
            <div className="ZhWhyCheckPlus-GooglePay" />
            <div className="ZhWhyCheckPlus-paymeBtn" />

            <div className="ZhWhyCheckPlus-subtitle">即將支援</div>
            <div className="ZhWhyCheckPlus-FPS" />
            <div className="ZhWhyCheckPlus-paypal" />
            <div className="ZhWhyCheckPlus-manualContainer">
              <div className="ZhWhyCheckPlus-alipay" />
              <div className="ZhWhyCheckPlus-wechatpay" />
              <div className="ZhWhyCheckPlus-octopus" />
            </div>
            <div className="ZhWhyCheckPlus-manualContainer">
              <div className="ZhWhyCheckPlus-bankTransfer"></div>
              <div className="ZhWhyCheckPlus-check" />
            </div>

            <div className="ZhWhyCheckPlus-heading4">4. 設定付款或捐款類型</div>
            <div className="ZhWhyCheckPlus-subheading">
              機構可以設定付款或捐款類型，以確保系統自動發出正確合規格的收據。
            </div>
            <div className="ZhWhyCheckPlus-feature4" />
            <div className="ZhWhyCheckPlus-heading4">
              5. 自動付款及捐款收據處理
            </div>
            <div className="ZhWhyCheckPlus-subheading">
              系統會即時自動處理捐款收據及發送至捐款者所提供的電郵地址。
            </div>
            <div className="ZhWhyCheckPlus-feature5" />
            <div className="ZhWhyCheckPlus-heading">6. 支援每月定期捐款</div>
            <div className="ZhWhyCheckPlus-feature6" />
            <div className="ZhWhyCheckPlus-heading4">7. 捐款者户口</div>
            <div className="ZhWhyCheckPlus-feature7"></div>

            <div className="ZhWhyCheckPlus-heading">8. 自動準備報告</div>
            <div className="ZhWhyCheckPlus-feature8" />
          </div>
        </div>

        <div className="ZhWhyCheckPlus-section5">
          <div className="ZhWhyCheckPlus-verticalLogo" />
          <div className="ZhWhyCheckPlus-txt ZhWhyCheckPlus-description5">
            立即登記 CheckPlus
          </div>
          <Link to="/OrgLogin">
            <div className="ZhWhyCheckPlus-first-bar">立即登記</div>
          </Link>
        </div>

        <div className="ZhWhyCheckPlus-footer">
          <div className="ZhWhyCheckPlus-footerNav">
            <Link to="/ZhTeam">
              <div className="ZhWhyCheckPlus-footerNavItem">創辦人的故事</div>
            </Link>
            <Link to="/ZhFaq">
              <div className="ZhWhyCheckPlus-footerNavItem">常見問題</div>
            </Link>
            <Link to="/ZhContact">
              <div className="ZhWhyCheckPlus-footerNavItem">聯絡我們</div>
            </Link>

            <Link to="/ZhPrivacyPolicy">
              <div className="ZhWhyCheckPlus-footerNavItem">私隱政策</div>
            </Link>

            <Link to="/ZhTerms">
              <div className="En-footerNavItem">使用條款</div>
            </Link>
          </div>

          <div className="ZhWhyCheckPlus-footer_text">
            香港九龍油塘四山街 11 號
            <br />
            華利工業大廈 5 樓 A 室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切權利。
          </div>
        </div>
      </div>
    );
  }
}

export default ZhWhyCheckPlus;
